import { render, staticRenderFns } from "./ProductRoast.vue?vue&type=template&id=0054cd82&scoped=true&lang=pug"
import script from "./ProductRoast.vue?vue&type=script&lang=js"
export * from "./ProductRoast.vue?vue&type=script&lang=js"
import style0 from "./ProductRoast.vue?vue&type=style&index=0&id=0054cd82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054cd82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0054cd82')) {
      api.createRecord('0054cd82', component.options)
    } else {
      api.reload('0054cd82', component.options)
    }
    module.hot.accept("./ProductRoast.vue?vue&type=template&id=0054cd82&scoped=true&lang=pug", function () {
      api.rerender('0054cd82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductRoast.vue"
export default component.exports